export default __webpack_public_path__ + "_/images/cocktail/cocktail-liquid-b0aff19abfac88ae117b2e90e87584e47c9a6ea1c70f3164714e694543eb5d2b.png";